import { tr } from "../../i18n";

/** Icon shown on a product tile when the product has no picture. */
const CATEGORY_ICONS = {
  juice: "🧪",
  device: "🔋",
  accessory: "🔧",
  coil: "🌀",
  cotton: "☁️",
  puff: "💨",
  kit: "🎒",
  pod: "💠",
  pack: "🎁",
};

export const categoryIcon = (category) => CATEGORY_ICONS[category] || "📦";

/** Short plural label for the category filter chips, in the device's language. */
export const categoryLabel = (category) => {
  if (!category) return tr("common.categories.other");

  const key = `common.categoriesPlural.${category}`;
  const label = tr(key);

  return label === key
    ? category.charAt(0).toUpperCase() + category.slice(1)
    : label;
};
